import type { PrefetchContext, PrefetchedDataProps } from 'src/shared/prefetch';

import { useCountryCode, useLocale } from 'src/app/shared/hooks/l10n';

import { prefetchImpactPageDataFromApi, useImpactPageDataFromApi } from './pageData';

export type ImpactPagePrefetchedContext = Readonly<{
	pageData: Parameters<typeof useImpactPageDataFromApi>[0];
}>;

export type ImpactPageCombinedState = ReturnType<typeof useImpactPageDataFromApi>;

export function usePageContext(prefetchedData?: ImpactPagePrefetchedContext): ImpactPageCombinedState {
	const locale = useLocale();
	const countryCode = useCountryCode();
	return useImpactPageDataFromApi(prefetchedData?.pageData, { locale, countryCode });
}

export async function prefetchPageContext(context: PrefetchContext): Promise<ImpactPagePrefetchedContext> {
	const pageData = await prefetchImpactPageDataFromApi(context, {
		countryCode: context.l10n.countryCode,
		locale: context.l10n.locale,
	});

	return { pageData };
}

export type ImpactPagePrefetchedDataProps = PrefetchedDataProps<ImpactPagePrefetchedContext>;
